import { anchorItemDataProvider } from 'site-modules/personalized-search/data-providers/anchor-item-data-provider';
import { headerContentDataProvider } from 'site-modules/personalized-search/data-providers/header-content-data-provider';
import { overviewItemDataProvider } from 'site-modules/personalized-search/data-providers/overview-item-data-provider';
import { highlightsDataProvider } from 'site-modules/personalized-search/data-providers/highlights-data-provider';
import { opinionDataProvider } from 'site-modules/personalized-search/data-providers/opinion-data-provider';
import { inventoryDataProvider } from 'site-modules/personalized-search/data-providers/inventory-data-provider';
import { overviewCtaDataProvider } from 'site-modules/personalized-search/data-providers/overview-cta-data-provider';
import { dealershipItemDataProvider } from 'site-modules/personalized-search/data-providers/dealership-item-data-provider';
import { learnMoreDataProvider } from 'site-modules/personalized-search/data-providers/learn-more-data-provider';
import { vinDataProvider } from 'site-modules/personalized-search/data-providers/vin-data-provider';
import { verdictDataProvider } from 'site-modules/personalized-search/data-providers/verdict-data-provider';

export const dataProviders = {
  anchorItemDataProvider,
  headerContentDataProvider,
  overviewItemDataProvider,
  highlightsDataProvider,
  opinionDataProvider,
  overviewCtaDataProvider,
  inventoryDataProvider,
  dealershipItemDataProvider,
  learnMoreDataProvider,
  vinDataProvider,
  verdictDataProvider,
};
